const Blockquote = {
  baseStyle: {
    backgroundColor: 'blue.50',
    fontStyle: 'italic',
    padding: 4,
  },
};

export default Blockquote;
